import { Grid } from '@mui/material';
import { StyledButtonConfirmar } from './styles';
import ButtonContent from './ButtonContent';

const SubmitButton = ({ isLoading, align, buttonText = 'Confirmar' }) => {
  return (
    <Grid
      item
      container
      sx={{ justifyContent: { xs: 'center', md: align || 'end' } }}
    >
      <StyledButtonConfirmar type="submit" disabled={isLoading} align={align}>
        <ButtonContent isLoading={isLoading}>{buttonText}</ButtonContent>
      </StyledButtonConfirmar>
    </Grid>
  );
};

export default SubmitButton;
